import { MainBlock } from '@blocks/BlockMain/model'

export const mainBlock: MainBlock = {
	title: 'Рефинансируйте микрокредиты под залог квартиры',
	textItems: [
		'Объединим все микрокредиты в один',
		'Значительно снизим платёж',
		'Дадим дополнительную сумму на любые цели',
	],
	buttonText: 'Оставить заявку',
	faceImageName: {
		mobile: 'KV-loans-business-mob.png',
		default: 'keyvisual-loans-business.png',
	},
	imageAlt: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
}
